import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, FormBuilder, ReactiveFormsModule } from '@angular/forms';

import { AuthService } from "./services/auth.service";
import { AuthGuardService } from "./services/auth-guard.service";
import { PhoneMaskDirective } from './directives/phone-mask.directive';
import { EmailValidator } from "./validators/email.validation";
import { PhoneValidator } from "./validators/phone.validation";
import { UtilService } from "./services/util.service";
import { FilterPipe } from './pipes/filter.pipe';
import { FilterActivePipe } from './pipes/filter-active.pipe';
import { SortPipe } from './pipes/sort.pipe';
import { FilterService } from "./services/filter.service";
import { SortService } from "./services/sort.service";
import { PhoneMaskPipe } from './pipes/phone-mask.pipe';
import { CapitalizePipe } from './pipes/capitalize.pipe';
import { AutoCompleteComponent } from "./components/autocomplete/autocomplete.component";
import { AutoCompleteService } from "./components/autocomplete/autocomplete.service";
import { DatepickerDirective } from './directives/datepicker.directive';
import { CepMaskDirective } from "./directives/cep-mask.directive";
import { NumberIntegerDirective } from "./directives/number-integer-mask.directive";
import { CnpjValidator } from "./validators/cnpj.validation";
import { CnpjMaskDirective } from "./directives/cnpj-mask.directive";
import { CnpjMaskPipe } from "./pipes/cnpj-mask.pipe";
import { LicensePlateMaskPipe } from "./pipes/license-plate-mask.pipe";
import { LicensePlateMaskDirective } from "./directives/license-plate-mask.directive";
import { GroupByService } from "./services/group-by.service";
import { CurrencyMaskPipe } from "./pipes/currency-mask.pipe";
import { FilterNumberPipe } from "./pipes/filter-number.pipe";
import { CurrencyMaskDirective } from "./directives/currency-mask.directive";
import { CpfMaskDirective } from "./directives/cpf-mask.directive";
import { CpfValidator } from "./validators/cpf.validation";
import { CpfMaskPipe } from "./pipes/cpf-mask.pipe";
import { AutoCompleteInsertComponent } from "./components/autocomplete-insert/autocomplete-insert.component";
import { AutoCompleteInsertService } from "./components/autocomplete-insert/autocomplete-insert.service";
import { SpinnerComponent } from "./components/spinner/spinner.component";
import { CodigoMaskPipe } from "./pipes/codigo.pipe";
import { CodigoMaskMaskDirective } from "./directives/codigo-mask.directive";
import { Gtin13MaskDirective } from "./directives/gtin-13-mask.directive";
import { Gtin13Pipe } from "./pipes/gtin-13.pipe";
import { OdometroHorimetroMaskDirective } from "./directives/odometro-horimetro-mask.directive";
import { OdometroHorimetroMaskPipe } from "./pipes/odometro-horimetro-mask.pipe";
import { NumberValidator } from "./validators/number.validation";
import { LiterMaskPipe } from "./pipes/liter-mask.pipe";
import { NumberMaxMinValueValidator } from "./validators/number-max-min-value.validation";
import {TimepickerDirective} from "./directives/timepicker.directive";
import {OdometroHorimetroValidator} from "./validators/odometro-horimetro.validation";
import {AttService} from "./services/att.service";
import {ExportCsvService} from "./services/export-csv.service";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule
    ],
    providers: [
        FormBuilder,
        AuthService,
        AuthGuardService,
        UtilService,
        FilterService,
        SortService,
        GroupByService,
        AutoCompleteService,
        AutoCompleteInsertService,
        AttService,
        ExportCsvService,

        EmailValidator,
        PhoneValidator,
        CnpjValidator,
        CpfValidator,
        NumberValidator,
        NumberMaxMinValueValidator,
        OdometroHorimetroValidator
    ],
    declarations: [
        AutoCompleteComponent,
        AutoCompleteInsertComponent,
        SpinnerComponent,

        PhoneMaskDirective,
        DatepickerDirective,
        TimepickerDirective,
        CepMaskDirective,
        NumberIntegerDirective,
        CnpjMaskDirective,
        LicensePlateMaskDirective,
        CurrencyMaskDirective,
        CpfMaskDirective,
        CodigoMaskMaskDirective,
        Gtin13MaskDirective,
        OdometroHorimetroMaskDirective,

        FilterPipe,
        FilterActivePipe,
        FilterNumberPipe,
        SortPipe,
        PhoneMaskPipe,
        CapitalizePipe,
        CnpjMaskPipe,
        LicensePlateMaskPipe,
        CurrencyMaskPipe,
        CpfMaskPipe,
        CodigoMaskPipe,
        Gtin13Pipe,
        OdometroHorimetroMaskPipe,
        LiterMaskPipe
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,

        AutoCompleteComponent,
        AutoCompleteInsertComponent,
        SpinnerComponent,

        PhoneMaskDirective,
        DatepickerDirective,
        TimepickerDirective,
        CepMaskDirective,
        NumberIntegerDirective,
        CnpjMaskDirective,
        LicensePlateMaskDirective,
        CurrencyMaskDirective,
        CpfMaskDirective,
        CodigoMaskMaskDirective,
        Gtin13MaskDirective,
        OdometroHorimetroMaskDirective,

        FilterPipe,
        FilterActivePipe,
        FilterNumberPipe,
        SortPipe,
        PhoneMaskPipe,
        CapitalizePipe,
        CnpjMaskPipe,
        LicensePlateMaskPipe,
        CurrencyMaskPipe,
        CpfMaskPipe,
        CodigoMaskPipe,
        Gtin13Pipe,
        OdometroHorimetroMaskPipe,
        LiterMaskPipe
    ]
})
export class SharedModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/shared/shared.module.ts
 **/